import { graphql, useStaticQuery } from 'gatsby'
import { useIntl } from 'gatsby-plugin-react-intl'
import { usePostHog } from 'posthog-js/react'
import { FC, useState } from 'react'
import { Rating } from 'react-simple-star-rating'

import supabase from '../../client'
import { useIntlLabel } from '../../intl'
import { ratingTooltipArray } from '../../types'
import { ButtonStyled } from '../common/Button/styles'
import { SurveyQuery } from './__generated__/SurveyQuery'
import {
    ButtonWrapperStyled,
    SurveyInner,
    SurveyLabel,
    SurveyTextArea,
    SurveyTitle,
    SurveyWrapper,
} from './styles'

interface SurveyProps {
    slug: string
}

const Survey: FC<SurveyProps> = ({ slug }) => {
    const [rate, setRate] = useState(0)
    const [loading, setLoading] = useState(false)
    const [textArea, setTextArea] = useState('')
    const posthog = usePostHog()

    const intl = useIntl()
    const getIntlLabel = useIntlLabel()
    const { strapiGlobal } = useStaticQuery<SurveyQuery>(
        graphql`
            query SurveyQuery {
                strapiGlobal {
                    usedInformation
                    usedInformation_mg
                    helpInComment
                    helpInComment_mg
                    submitButton
                    submitButton_mg
                }
            }
        `,
    )

    const handleRating = (rate: number) => {
        setRate(rate)
    }

    const handleClick = async () => {
        setLoading(true)
        const { error } = await supabase.from('ratings').insert({
            rate: rate,
            slug: slug,
            comment: textArea,
        })

        posthog?.capture('service_rated', {
            serviceName: slug,
            rate: rate,
        })

        setLoading(false)
        setRate(0)
        setTextArea('')
    }

    const handleMessage = (object: any) => {
        setTextArea(object.target.value)
    }

    return (
        <SurveyWrapper>
            <SurveyInner>
                <SurveyTitle>{getIntlLabel(strapiGlobal, 'usedInformation')}</SurveyTitle>
                <Rating
                    onClick={handleRating}
                    initialValue={rate}
                    size={32}
                    showTooltip
                    tooltipDefaultText={intl.formatMessage({ id: 'label_note' })}
                    tooltipArray={ratingTooltipArray}
                />
                <SurveyLabel>{getIntlLabel(strapiGlobal, 'helpInComment')}</SurveyLabel>
                <SurveyTextArea value={textArea} onChange={handleMessage} />
                <ButtonWrapperStyled>
                    <ButtonStyled color="primary" onClick={handleClick} disabled={loading}>
                        {loading
                            ? intl.formatMessage({ id: 'contact_button_loading' })
                            : intl.formatMessage({ id: 'contact_button_text' })}
                    </ButtonStyled>
                </ButtonWrapperStyled>
            </SurveyInner>
        </SurveyWrapper>
    )
}

export default Survey
